// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"4c1d753c","96":"6b9c4481","821":"618d2075"}[chunkId] + ".chunk.js";
};